import React from 'react';

// Interface para as props do componente
export interface IconProps {
    path: string;
    size?: number;
    color?: string;
    title?: string;
    spin?: boolean | number;
    horizontal?: boolean;
    vertical?: boolean;
    rotate?: number;
    [key: string]: any;
}

/**
 * Componente wrapper para o Icon do @mdi/react para resolver problemas de tipagem
 * com versões mais recentes do React
 */
export const Icon = ({
    path,
    size = 1,
    color = 'currentColor',
    spin = false,
    horizontal = false,
    vertical = false,
    rotate = 0,
    title,
    ...props
}: IconProps) => {
    const pathStyle = {};
    const svgStyle = { width: `${size}rem`, height: `${size}rem` };

    let transformations: string[] = [];

    if (horizontal) {
        transformations.push('scaleX(-1)');
    }

    if (vertical) {
        transformations.push('scaleY(-1)');
    }

    if (rotate !== 0) {
        transformations.push(`rotate(${rotate}deg)`);
    }

    const styleTransform = transformations.length > 0 ? { transform: transformations.join(' ') } : {};

    let spinSec = 2;
    let spinStyle = {};

    if (typeof spin === 'number') {
        spinSec = spin;
    }

    if (spin) {
        spinStyle = {
            animation: `spin-around ${spinSec}s infinite linear`,
        };
    }

    const combinedStyle = {
        ...svgStyle,
        ...styleTransform,
        ...spinStyle,
        ...props.style
    };

    return (
        <svg
            viewBox="0 0 24 24"
            style={combinedStyle}
            {...props}
        >
            {title && <title>{title}</title>}
            <path d={path} style={pathStyle} fill={color} />
        </svg>
    );
};

// Adiciona uma regra de CSS para animação de rotação
if (typeof document !== 'undefined') {
    if (!document.querySelector('style#icon-wrapper-style')) {
        const style = document.createElement('style');
        style.id = 'icon-wrapper-style';
        style.textContent = `
      @keyframes spin-around {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `;
        document.head.appendChild(style);
    }
}

export default Icon;
